export default "__VITE_ASSET__3eca69f8__"